import axios, { axiosV2 } from "@axios" //eslint-disable-line

export default {
    /*
     * main clients API
     */
    getClients() {
        return axios.get('/accounts/clients')
    },
    getClientsByUuids(params = {}) {
        return axios.post('/accounts/clients', params)
    },
    getClient(uuid, params = {}) {
        return axios.get(`/accounts/clients/${uuid}`, { params })
    },
    getClientAccountPlan(accountUuid) {
        return axiosV2.get(`/account-plans/${accountUuid}/client`)
    },
}
